import styled from "styled-components";
import { primitives } from "../../primitives";
export const FormFieldWrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
});

export const FormFieldLabel = styled.label<{
  hasError?: boolean;
}>(
  {
    display: "flex",
    fontSize: "1.2em",
    marginBottom: "4px",
    fontWeight: 400,
    color: "#333333",
  },
  ({ hasError }) => ({
    color: hasError ? primitives.colors.red[700] : primitives.colors.grey[700],
  })
);

export const RequiredLabel = styled.span({
  color: primitives.colors.red[700],
});

export const FormFieldDescription = styled.p({
  fontSize: "14px",
  color: primitives.colors.grey[500],
  marginTop: "4px",
  marginBottom: 0,
});

export const ErrorText = styled.p<{ hasError?: boolean }>(
  {
    color: primitives.colors.red[700],
    marginTop: "4px",
    marginBottom: 0,
    height: "22px",
  },
  ({ hasError }) => ({ visibility: hasError ? "visible" : "hidden" })
);
